import * as Linking from "expo-linking";
import { Platform } from "react-native";

export function getAppUrl(path = "") {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (Platform.OS === "web") {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    return `${origin.replace(/\/+$/, "")}${normalizedPath}`;
  }
  return Linking.createURL(normalizedPath.replace(/^\//, ""));
}
